import type { I18n } from '@/typings/i18n'

const zhCN: I18n = {
  global: {
    indexTitle: 'LOOK',
    tipsTitle: '提示',
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    day: '天',
    people: '人',
    bindButtonText: '绑定',
    help: '帮助',
    manageSubscription: '管理订阅',
    coupon: '查看优惠券',
    deleteMessage: '确定删除吗？',
    deleteButtonText: '删除',
    renameButtonText: '重命名',
    downloadButtonText: '点击下载',
    install: '安装',
    phoneNumberLabel: '输入手机号码',
    verificationCodeLabel: '输入验证码',
    sendButtonText: '发送',
    saveButtonText: '保存',
    download: '下载',
    complete: '完成',
    adjustButtonText: '调整',
    eraser: '橡皮',
    undo: '撤消',
    redo: '重做',
    clear: '清除',
    noDataMessage: '暂无数据',
    loading: '加载中',
    customize: '自定义',
    referenceImage: '参考图',
    styleImage: '款式图',
    high: '高',
    middle: '中',
    low: '低',
    big: '大',
    small: '小',
    select: '选择',
    upload: '上传',
    colon: '：',
    uploadDesc: '点击或者拖动文件到该区域来上传',
    generate: '生成',
    preview: '预览',
    magic: '智能',
    add: '添加',
    subtract: '减少',
    brush: '笔刷',
    part: '局部',
    commonlyUsed: '常用',
    recommend: '推荐',
    termsOfService: '《服务条款》',
    userAgreement: '《用户协议》',
    privacyStatement: '《隐私声明》',
    billingSupport: '账单支持',
    wechat: '微信',
    xiaohongshu: '小红书',
    downloadClient: '下载客户端',
    ok: '好的',
    and: '和',
    language: '语言',
    copy: '复制',
    copyLink: '复制链接',
    signupTitle: '注册',
    signupTitleSuffix: 'LOOK AI 实时时装设计工具',
    recentsTitle: '最近生成 - LOOK',
    projectNameTitle: '{projectName} - LOOK',
    nextStep: '下一步',
    accept: '接受',
    reject: '拒绝',
    about: '关于',
    subscribeToNews: '订阅我们的新闻',
    subscribeToNewsDesc: '不要错过最新的新闻和更新！',
    agree: '同意',
    deny: '拒绝',
    close: '关闭',
    skip: '跳过',
    iKnow: '我知道了',
    modelSelection: '模型选择',
    account: '账号',
    password: '密码',
    login: '登录',
    upgrade: '升级',
    modeSelection: '模式选择',
    prompt: '提示词'
  },
  system: {
    updateTip: '新版本已下载完成，点击更新',
    updateMessage: '确定关闭应用并安装更新吗？',
    drawingDownMessage: ' 功能需要下载客户端使用，',
    bonjourInstallTitle: 'Bonjour未安装',
    bonjourInstallMessage1: '检测到投屏接收服务未安装，',
    bonjourInstallMessage2: ' 功能无法正常运行，请下载并安装 bonjour ，然后重新启动LOOK。',
    bonjourInstallMessage3: '若下载后依然无法使用请点击 仍无法使用。',
    bonjourUnavailableTitle: 'Bonjour未成功安装',
    bonjourUnavailableMessage1: '检测到投屏接收服务未成功安装，实时设计功能无法正常运行。',
    bonjourUnavailableMessage2: '请跟随视频引导强力卸载',
    bonjourUnavailableMessage3: '再重新安装 Bonjour 投屏接收服务，然后重新启动LOOK。',
    bonjourUnavailableMessage4Local:
      '若下载后依然无法使用请前往公众号【LOOK AI设计】，下方菜单中点击「更多服务」，选择「人工客服」扫码添加。',
    bonjourUnavailableMessage4: '若下载后依然无法使用请前往discord：',
    bonjourStartTitle: 'Bonjour未正常启动',
    bonjourStartMessage1:
      '检测到投屏接收服务未正常启动，实时设计功能无法正常运行，请跟随引导步骤启动',
    bonjourStartMessage2: '然后',
    bonjourStartMessage3: '重新启动LOOK',
    bonjourStartMessage4: '1、打开系统设置，搜索"服务"',
    bonjourStartMessage5: '2、在服务中右键点击 Bonjour，选择"启动"',
    bonjourStartMessage6: '3、重新打开 LOOK 即可使用',
    bonjourStartMessage7Local:
      '若重新启动后依然无法使用请前往公众号【LOOK AI设计】，下方菜单中点击「更多服务」，选择「人工客服」扫码添加。',
    bonjourStartMessage7: '若重新启动后依然无法使用请前往discord：',
    bonjourStartText: '正常启动',
    bonjourUnavailable: '仍无法使用',
    bonjourDownload: 'Bonjour 下载',
    revoUninstaller: '强力卸载工具',
    forceUninstallMessage:
      '注意：如果你已安装投屏接收服务，但仍然反复提示检测到投屏接收服务未安装，可能由于投屏接收服务未完全安装成功，可以尝试使用强力卸载工具，将Bonjour 和 Bonjour SDK 两个应用卸载后，重新尝试安装投屏接收服务。',
    guideButtonText: '使用教程',
    noImageMessage: '未选择图片',
    aboutUsTitle: '关于我们',
    weChatPublicAccountTitle: '微信公众号',
    error400: '请求参数不正确',
    error403: '拒绝访问',
    error404: '请求地址不存在',
    error408: '请求超时',
    error500: '服务器内部错误',
    error501: '服务器未实现',
    error502: '网关错误',
    error503: '服务不可用',
    error504: '网关超时',
    copySuccess: '复制成功',
    copyError: '复制失败：',
    browserTips: '为了更好的使用体验，请使用Chrome浏览器访问或',
    serviceStopMessage: '您的Pro订阅已于：{date}自动续费失败,超期未支付将会停止服务。',
    renewalReminderMessage: '如需继续使用请',
    paymentLink: '点击完成订阅支付',
    updateTipsMessage:
      '为了带给您更好的使用体验,LOOK将在2024-11-2020:00 CSST进行系统更新,预计需要1-2小时完成。感谢您的耐心等待!',
    osVersionNotSupportedMessageWindows:
      'Windows 10 64位以下操作系统版本不受支持，可能会影响你的使用体验，建议升级操作系统或使用浏览器访问。',
    osVersionNotSupportedMessageMacOS:
      'Mac OS 13以下操作系统版本不受支持，可能会影响你的使用体验，建议升级操作系统或使用浏览器访问。',
    updatedDownloadMessage: 'LOOK 检测到新版本，将自动关闭且安装更新。',
    receiverConnectErrorMessage: '投屏接收端连接错误：{message}',
    receiverStartErrorMessage: '投屏接收端启动错误：{message}',
    macOSVersionErrorMessage: '投屏接收端启动错误：Mac OS 版本过低，请升级操作系统。',
    airplayRTPErrorMessage: 'AirPlay 投屏遇到网络错误，请检查网络连接后，尝试重新启动 LOOK。',
    networkDisconnectedMessage: '网络连接已断开，投屏已停止。请检查网络连接。',
    networkReconnectedMessage: '网络已重新连接。如需继续投屏，请重启 LOOK 并重新连接设备。',
    downloadButtonTextMac: '下载 macOS 版',
    downloadButtonTextWindows: '下载 Windows 版',
    slogan1: 'AI 服装实时设计',
    slogan2: '实时呈现你的创意！',
    slogan3: '实时设计，实时呈现真实效果',
    slogan4: '线稿即刻生成效果图，批量生成衍生款',
    slogan5: '风格融合，突破想象力边界',
    slogan6: '局部调整，精准控制 AI',
    networkErrorMessage: '当前网络未连接，请检查当前设备的网络设置',
    serverErrorMessage: '服务器访问失败，请稍后再试',
    languageChangeMessage: '切换成该语言需要重新登录，确定切换吗？',
    consentTitle: 'Cookie 声明',
    consentTips:
      '为了为你提供更好的服务和个性化体验，我们使用 Cookie 和类似技术来分析网站性能、展示个性化广告以及提供社交媒体功能。通过点击"接受所有 Cookie "或继续使用本网站，即表示你同意使用分析性 Cookie 和追踪 Cookie，这些 Cookie 使我们能够提供更个性化的体验。查看我们的<span style="font-weight: 700; text-decoration: underline; cursor: pointer">Cookie 声明</span>以了解更多关于我们使用的 Cookie。',
    aboutTitle: 'LOOK 桌面应用',
    currentVersion: '版本',
    newVersion: '新版本',
    copyright: 'Copyright © 2024 LOOK AI LIMITED',
    copyrightLocal: '版权所有 © 2025 基本操作（深圳）科技有限公司',
    checkUpdateButtonText: '检查更新',
    updateButtonText: '更新至 {version}',
    noUpdateMessage: '已是最新版本',
    updateFailMessage: '更新失败，重启 LOOK 后会尝试重新更新',
    appDownloadGuideTitle: '下载 LOOK 电脑客户端',
    appDownloadGuideSubTitle: '功能需要下载 LOOK 电脑客户端使用。',
    realtimeDesignGuideTitle: '实时设计引导',
    realtimeDesignGuideSubTitle1:
      '实时设计功能需要下载 <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> LOOK 电脑客户端，配合 <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> Procreate 应用一起同步使用。',
    realtimeDesignGuideSubTitle2:
      '请打开 <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> Procreate 和 <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> LOOK 电脑客户端，跟随引导完成投屏连接。',
    freeCountLimitDialogTitle: '已达到生成限制？',
    freeCountLimitDialogDesc:
      '首次下载并登录应用程序可获得<br/><span style="font-weight: 600; font-size: 24px">额外1天免费试用</span>',
    freeCountLimitDialogDescMobile:
      '首次在 <span style="font-weight: 600">PC 或 macOS</span> 上<br/>下载并登录应用程序，可获得<br/><span style="font-weight: 600;font-size: 24px">额外1天免费试用</span>',
    imageSizeTooLarge: '图片不能大于 {size}MB'
  },
  error: {
    invitationCodeUsed: '邀请码已被使用',
    invitationCodeInvalid: '邀请码无效',
    networkErrorTitle: '网络错误',
    networkErrorMessage: '无法连接到服务器，请检查网络连接后重试',
    retryButtonText: '重试',
    upscaleScaleError: '错误的放大倍数, 可能是无权限或不支持的倍数',
    campaignSystemError: '系统错误，请稍后重试',
    campaignUserAuthError: '获取用户身份失败',
    campaignParamError: '参数异常',
    campaignQueryError: '查询异常',
    campaignNotCompleted: '活动任务尚未完成',
    campaignRewardAlreadyClaimed: '奖励已领取',
    campaignCouponNotAvailable: '优惠券不可用',
    campaignUseCoupon: '使用优惠券失败',
    campaignAssignCoupon: '发放优惠券失败',
    userGoogleAuthFail: 'Google 登录失败',
    userNotSupportLoginType: '不支持的登录方式',
    userSystemError: '系统错误',
    userLoginError: '登录失败'
  },
  account: {
    logoutMessage: '确定登出吗？',
    logoutButtonText: '退出登录',
    bindPhoneTitle: '请完成手机绑定',
    bindPhoneSuccessMessage: '绑定手机成功',
    bindPhoneTips: '绑定手机号获得免费会员',
    bindPhoneEmptyNumberMessage: '请输入手机号码',
    bindPhoneErrorNumberMessage: '请输入正确的手机号',
    bindPhoneVerificationCodeEmptyMessage: '请输入验证码',
    getInvitationCodeErrorMessage: '获取邀请码信息失败',
    trialDuration: '试用时长：',
    trialDurationYearlyCoupon: '1天免费试用 & 额外30%优惠',
    trialExtraText: '获得额外30%优惠',
    headerGiftText: '领取代金券',
    headerGiftTextLocal: '领取免费会员',
    headerOneDayGiftText: '开通会员{discount}折优惠',
    headerSubscribeGiftText: '立即订阅',
    invitePopoverTitle: '邀请好友',
    invitePopoverDescTips: '新用户绑定手机视为成功邀请新用户',
    invitePopoverMark: '领取&nbsp;<span>$15</span>&nbsp;代金券！',
    invitePopoverMarkLocal: '领取&nbsp;<span>15</span>&nbsp;天免费使用！',
    invitePopoverDesc:
      '每邀请1位好友，你将获得$15代金券，可在订阅/续费时抵扣！',
    invitePopoverDescLocal: '每邀请 1 位好友，你将获得15天免费使用！',
    invitePopoverCodeShareTitle: '扫码分享',
    invitePopoverCodeCopyTitle: '点击复制邀请码',
    invitePopoverShareCountText: '剩余可邀请：',
    invitePopoverSubText: '邀请码次数根据使用情况系统自动派发。',
    invitePopoverGiftDaysText: '累积获得代金券：',
    invitePopoverGiftDaysTextLocal: '累积获得免费天数：',
    invitePopoverBindPhoneMaskText: '绑定手机激活并获得邀请名额',
    phoneNumber: '手机号：',
    noMemberText: '未开通会员',
    memberExpireAtFormat: 'YYYY年MM月DD日',
    memberExpireAt: '到期时间：',
    memberUpgradeMainText: '提升生成上限 高清4K图片',
    memberUpgradeMainTextFirst: '领取5折优惠！',
    memberUpgradeSubText: '实现实时设计自由！',
    memberUpgradeLinkTextActivate: '去开通',
    memberUpgradeLinkTextUpgrade: '去升级',
    memberUpgradeLinkTextGet: '去领取',
    memberUpgradeLinkTextManage: '管理',
    discordLoginTitle: '从 LOOK 开始',
    discordLoginButtonText: '使用 Discord 登录',
    discordLoginSubText1: '通过注册，你将创建一个 LOOK 账户并同意 LOOK 的 ',
    discordLoginSubText2: '',
    googleLoginButtonText: '使用 Google 登录',
    invitePageTitle: '你好，设计师',
    invitePageNicknamePlaceholder: '用户昵称',
    invitePageInvitationCodePlaceholder: '邀请码',
    invitePageSubmitButtonText: '注册',
    invitePageTips: '使用邀请码<span style="font-weight: 700">可获额外8天免费试用</span>',
    invitePageInvitationCodeInvalid: '邀请码无效',
    hasInvitationCodeText: '我有邀请码',
    shareInvitationCodeText: `LOOK AI 实时服装设计工具

💻 电脑访问：https://app.lookfashion.ai
📱 暂时不支持手机使用

邀请码：{code}`,
    shareInvitationCodeTextLocal: `LOOK AI 实时服装设计工具

💻 电脑访问：https://look-ai.cn
📱 暂时不支持手机使用

邀请码：{code}`,
    limitedTitle: '请稍等...',
    // TODO: 未考虑实时设计场景
    limitedSubject: '您已达到 <span style="font-weight: 600">{name}</span> 生成上限，',
    limitedTime: '你可以在 {time} 后继续使用。',
    limitedRealtimeDesignTime: '请在下一个订阅周期继续使用。',
    upgradeTitle: '不想等待？',
    upgradeSubject: '升级会员 <span style="font-weight: 600">马上</span> 生成！',
    upgradeButtonText: '立即升级',
    mergeAccount: '这是你吗?',
    mergeAccountDesc: '是的，绑定账号',
    mergeAccountCancel: '不是，返回登录',
    recentLoginText: '上次登录',
    passwordLoginButtonText: '账号密码登录',
    usernameErrorMessage: '请输入账号',
    passwordErrorMessage: '请输入密码'
  },
  project: {
    recentListTitle: '最近生成',
    collectListTitle: '收藏列表',
    projectListTitle: '项目列表',
    emptyMessage1: '还未创建项目',
    emptyMessage2: '点击下方创建项目',
    emptyMessage3: '开始生成',
    emptyMessage4: '还未保存任何图片，生成并',
    emptyMessage5: '保存以添加图片',
    emptyMessage6: '先新建项目然后在项目内生成并',
    emptyMessage7: '保存LOOK',
    createProjectButtonText: '新建项目',
    projectNamePlaceholder: '请输入项目名称',
    projectEnterText1: '进入当前项目',
    projectEnterText2: '进入工作台',
    createProjectTip: '请先创建项目'
  },
  image: {
    text2ImageTitle: '文生图',
    originalityTitle: '线稿生图',
    styleExtensionTitle: '款式延伸',
    styleFuseTitle: '风格融合',
    tuneTitle: '局部修改',
    recolorTitle: '智能换色',
    backgroundTitle: 'AI 换场景',
    eraserTitle: '魔术擦除',
    cutoutTitle: '一键抠图',
    flowerPatternExpansionTitle: '四方连续',
    aiExpansionTitle: 'AI 扩图',
    hdTitle: '变清晰',
    drawingTitle: '实时设计',
    patternTitle: '花型贴图',
    imageCount: '张',
    generateButtonText: '生成 LOOK',
    generateButtonSubscribeBoxTitle1: '首次开通会员5折优惠',
    generateButtonSubscribeBoxTitle1Local: '首次开通会员{discount}折优惠',
    generateButtonSubscribeBoxTitle2: '解锁专业版',
    generateButtonSubscribeBoxDesc1: '免费体验到期了？立即使用优惠解锁更多生成特权！',
    generateButtonSubscribeBoxDesc2: '升级专业版，获得更多生成特权，实现实时设计自由！',
    generateButtonSubscribeBoxButtonText1: '去领取',
    generateButtonSubscribeBoxButtonText2: '升级Pro版',
    generateButtonSubscribeBoxButtonText2Local: '升级专业版',
    originalSizeText: '原始比例',
    uploadImageButtonText: '上传图片',
    uploadPatternButtonText: '图片',
    editMaskButtonText: '编辑蒙版',
    removeMaskButtonText: '删除蒙版',
    patternExpansionSize: '扩展大小',
    patternExpansionSizeSmall: '小',
    patternExpansionSizeMedium: '中',
    patternExpansionSizeLarge: '大',
    imageUploaderDesc:
      '<span style="color: #4c4c4c; font-size: 14px">点击或拖动以上传</span><br/> <span style="color: #b0b2ae; font-size: 12px">（下侧和右侧的保存区图片可直接拖动上传）</span>',
    generatePreviewText: '生成预览({count}/{max})',
    previewListHelpMessage1:
      '1.生成的图片临时存放在这列表中，最多存放{max}张图片，超过{max}张时，最早生成的图片会被删除。',
    previewListHelpMessage2: '2.临时图片需要保存到相册中才会被永久保存，及进行更多操作。',
    clearPreviewButtonText: '清除所有预览',
    segmentErrorMessage: '图片语义分析失败，请重试',
    generatingMessage: '图片生成中',
    previewWaitingMessage: '图片处理中，请稍等',
    previewFailedMessage: '图片处理失败，无法查看',
    imageInQueueMessage: '排队中',
    imageNotVerifyMessage: '图片违规',
    saveImageButtonText: '保存到相册',
    deleteTmpImageButtonText: '删除临时图片',
    previewImageInfoText: '图片信息',
    promptDefaultPlaceholder: '输入对设计的描述或描述提示词提高生成准确度',
    promptDefaultPlaceholder2: '填入对图案的描述',
    promptDefaultPlaceholder3: '填入对图片的描述',
    promptDefaultPlaceholder4: '输入对模特发型的描述',
    removeBgErrorMessage: '去背景失败',
    removeBgButtonText: '去背景',
    removeBgLoadingMessage: '正在去除背景，请稍等',
    cropTip1: '图片上下尽可能保留足够位置生成模特头部及腿部',
    cropTip2: '如上传图片过小，请裁剪到合适大小',
    diyModelText: '自定义模特',
    commonModelText: '公有模特',
    exclusiveModelText: '专属模特',
    promptTitle: '设计特征',
    promptTitle2: '花型描述',
    promptTitle3: '图片描述',
    promptTitle4: '发型描述',
    promptInputTitle: '设计特征（多选）',
    selectModelTitle: '模特选择',
    referenceStrengthLabel: '参考强度',
    modelSettingTitle: '模特设置',
    advancedSettingsTitle: '高级设置',
    negativePromptTitle: '不希望图片出现的内容',
    negativePromptPlaceholder: '输入或选择不希望图片中出现的元素',
    generateCountTitle: '生成张数',
    cleanerTitle: '去前景',
    maskSwitchViewButtonText: '切换视图',
    regenerateButtonText: '重新生成',
    imageLoadingMessage: '正在加载图片',
    maskGenerateFailedMessage: '制作蒙版失败',
    maskPreviewDialogConfirmButtonText1: '确定抠图',
    maskPreviewDialogConfirmButtonText2: '制作蒙版',
    maskPreviewDialogCancelButtonText: '继续修改',
    objectRemovalDialogCancelButtonText: '继续修改',
    objectRemovalFailedMessage: '去前景失败',
    magicMaskGenerateFailedMessage: '制作智能蒙版失败',
    partMaskDialogTitle: '局部选择',
    imageAnalyzingMessage: '图片分析中',
    cutout: '抠图',
    maskDialogConfirmButtonText1: '正在准备预览',
    maskDialogConfirmButtonText2: '生成预览',
    maskDialogConfirmTip: '卡住了？重试看看吧！',
    rangeOfChangeLabel: '变化幅度',
    lesser: '变化小',
    more: '变化大',
    disableModelDesc: '禁用模特，请确保线稿中没有模特',
    generateFailedMessage: '创建生成图片任务失败',
    taskNotEnoughTip: '已达最大同时生成任务数，请稍后再试',
    saveTip1: '保存{saveType}即保存图片后，自动进行变清晰操作，',
    saveTip2:
      '如果当前生成 LOOK 和{saveType}任务总数到达最大同时进行任务数，则暂时无法进行保存{saveType}操作。',
    promptButtonText1: 'AI 润色',
    promptButtonText2: '图片描述',
    promptButtonMessage: '请先输入设计特征',
    promptButtonFailMessage: '生成失败，请重试',
    colorMatchTitle: '色彩还原',
    colorMatchSubject: '时装画变照片',
    colorMatchDesc: '呈现面料真实色彩和质感',
    realTimeDesignDesc: '与传统软件不同，我们为每位用户提供专属服务器。这项计算服务原价$5/小时，助力闪电般快速的创意生成，且保障数据隐私安全！',
    flowerPatternExpansionStep1: '1.上传一张非四方连续的图案',
    flowerPatternExpansionStep2: '2.选择需要扩展的范围',
    flowerPatternExpansionStep3:
      '3.LOOK 通过扩展生成图案的边缘，将原图案变成四方连续图案。可保存或下载以用于后续的设计。',
    maskCreateText: '制作蒙版',
    highDefinitionRepair: '高清修复',
    consistency: '一致性',
    patternDescriptionTitle: '图案描述',
    patternExtractionTitle: '请框选需要提取的图案区域',
    patternExtractionTip: '尽量只框选需要的图案部分以提高出图质量。',
    promptTemplate: '提示词模板',
    patternExtractionTipTitle1: '提取图案，保持细节不变。',
    patternExtractionTipDesc1: '将图案里的花型提取出来，保持原图的花型样式和细节均不变，提取的时候不要改变花型的排布，按照原有的花型排布输出。',
    patternExtractionTipTitle2: '提取图案，补全缺失部分，保持细节不变。',
    patternExtractionTipDesc2: '将衣服上的印花图案提取出来，提取出来的图案跟衣服上的图案细节保持一致。补全图案缺失的部分。提取的时候不要改变印花图案的排布，按照原有的图案排布输出。',
    patternExtractionTipTitle3: '提取图案，补充细节以辅助 AI 识别。',
    patternExtractionTipDesc3: '将衣服上的印花图案提取出来，提取出来的图案跟衣服上的图案细节保持一致。图案中有________ 和 ________ 的元素，补全图案缺失的部分。提取的时候不要改变印花图案的排布，按照原有的图案排布输出。',
    clothingDescription: '提取要求',
    materialDescription: '材质描述',
    clothingDescriptionPlaceholder: '示例：提取上衣，上衣胸口有小鸟和花朵的图案。',
    patternDescriptionPlaceholder: '示例：图案上有小鸟和花朵。',
    materialConversionPlaceholder: '示例：转换为刺绣材质。',
    generationQualityTitle: '生成质量'
  },
  cleaner: {
    cleaner: '魔法擦除',
    maskDialogTitle: '选择擦除的区域',
    maskDesc: '请选择需要擦除的区域'
  },
  drawing: {
    generatingMessage: '正在生成，请稍等',
    startDrawingMessage: '请开始绘画',
    waitingScreenMessage: '等待投屏...',
    canvasCropperGuideMessage: '请在 LOOK 上将画面裁切到画布大小',
    startDrawingButtonText: '开始设计',
    stopDrawingButtonText: '绘画中，点击停止',
    videoNotSupportMessage: '当前浏览器不支持视频播放',
    canvasGuideMessage1:
      '在 iPad 启动 <img src="{image}" width="26" height="26" /> Procreate 并跟随引导关闭再打开<span style="font-weight: 700; text-decoration: underline">画布投射</span>，然后点击确定',
    canvasGuideMessage2:
      '注：之前已经打开了画布投射也需要<span style="font-weight: 700; text-decoration: underline">重新关闭再打开</span>画布投射，否则将会影响生成效果',
    castScreenGuideMessage1: '当前版本仅支持',
    castScreenGuideMessage2: ' Procreate 投屏',
    castScreenGuideMessage2After: '',
    castScreenGuideMessage3: '跟随引导打开 iPad 投屏连接&nbsp;{placeholder}',
    castScreenGuideMessage4: '（两台设备需在同一网络下）',
    screenPreviewTitle: '投屏预览',
    reCropButtonText: '重新裁剪'
  },
  hd: {
    hdTools: '高清修复',
    scaleTitle: '放大画质',
    imageClaritySD: '保存',
    imageClarityHD: '保存高清',
    imageClarityUHD: '保存超清',
    imageClarityTextSD: '标清',
    imageClarityTextHD: '高清',
    imageClarityTextUHD: '超清',
    generatingMessage: '正在生成，请稍等'
  },
  matte: {
    matteTools: '一键抠图',
    maskDialogTitle: '选择保留区域',
    maskDesc: '请选择需要保留的区域',
    magicLabel: '智能抠图'
  },
  originality: {
    lineDrawingTitle: '线稿',
    lineDrawingUploadTitle: '线稿上传',
    sampleClothesTitle: '样衣'
  },
  recolor: {
    recolorTools: '换色',
    maskDialogTitle: '选择换色区域',
    maskDesc: '请选择需要换色的区域',
    colorSelectTitle: '色彩选择',
    getColorWarningMessage: '当前浏览器不支持颜色吸管功能'
  },
  styleFusion: {
    referenceImageDialogTitle1: '款式图'
  },
  background: {
    maskDialogTitle: '选择保留区域',
    maskDesc: '请选择需要保留的区域',
    backgroundDialogTitle: '添加背景',
    backgroundDescTitle: '背景描述',
    promptInputPlaceholder: '输入对背景的描述提高生成准确度',
    referenceBackgroundTitle: '参考背景',
    intelligentFillLightLabel: '智能补光',
    backgroundGenerateTimeoutMessage: '生成背景超时，请重试',
    backgroundGenerateFailedMessage: '生成背景失败，请重试',
    addBackgroundTitle: '添加背景',
    backgroundSizeTitle: '背景尺寸',
    effectPreviewMessage: '效果预览',
    canvasEmptyMessage: '请先添加背景'
  },
  text2Image: {
    text2ImageTools: '文生图',
    textExampleMessage1:
      '一位意大利模特穿着 oversized 针织服装的 lookbook 照片，人物特写，衣服是由不同颜色纱线织成的格子针织衫，时尚品牌的户外服装，街头服装，以 Campbell Ady 的风格拍摄，摄影大片。',
    textExampleMessage2:
      '一位时尚的中国模特，穿着飘逸的长裙，新中式风格，低饱和度的衣服，衣服同色系的印花，上海时装周，T 台，现代的时尚美感的服装。',
    textExampleMessage3:
      '一个时尚模特特写，服装呈现结构分割，现代服装，简单，干净，流动感，丝绸和亚麻面料混搭，时尚杂志封面照片。',
    textExampleMessage4:
      '一位时尚模特穿着一件带有精美刺绣的白色衬衫。衬衫上饰有大面积的暗红色花卉图案和金色的刺绣细节，增添了复古的优雅气息。模特佩戴了一对金色的圆形耳环，发型整洁，发丝向后梳理，露出她的脸庞。背景是深绿色，衬托出模特的肤色和服装，使整体图像充满了浓厚的艺术感。照片色调柔和，低饱和度，营造出一种宁静而富有诗意的氛围。',
    textExampleMessage5:
      '一位时尚模特solo，穿着一件亮橙色宽松毛衣，采用厚重针织材质，高领设计，袖子略宽松。下装穿着一条深蓝色A字皮裙，材质有光泽，质感硬挺。较厚鞋底的高跟鞋，厚重的感觉。橙色边框蓝色蓝色镜片墨镜，整体造型未来感和戏剧性。采用高饱和度的色彩搭配，颜色对比强烈，给人一种鲜明而大胆的视觉效果。配饰和妆容独特且夸张，强调个性化和艺术性。简洁的背景。',
    textExampleMessage6:
      '一个年轻时尚女性身穿黄色荧光色的冲锋衣，站在日本的街头，蓝色的天空，自然光，上半身照',
    textExampleMessage7:
      '一个高雅的白人女性模特穿着深灰色极简主义V领超长大衣和马丁靴，Theo Angelopoulos 的摄影风格，来自品牌 Lemaire 羊绒面料，褶皱，交叠式门襟，静谧圣洁的氛围，雾天，森林',
    textExampleMessage8:
      '一个穿着大胆绿色针织毛衣的时尚女性，背景是紫色的。毛衣上有一个独特的图案，包括白色和蓝色元素，看起来像是抽象的脸孔。面料似乎是厚实的编织物，表明可能是羊毛或羊毛混纺材料，通常用于这种类型的服装以实现保暖和质地。版型宽松，袖子延伸至手腕以下，休闲、oversized。颜色鲜艳明亮，绿色主导整个外观，与黑色裤子形成对比，营造出引人注目的色彩搭配。整体风格前卫时尚，当代街头时尚范畴。',
    textExampleMessage9:
      '一个韩国时尚网红穿着一件宽松的淡蓝色牛仔衬衫，袖子宽大。衬衫看起来经过磨损处理，有几个破洞和褪色的区域，表明是复古风格。模特还穿着一条浅色的短裤，可能是牛仔布料，与衬衫相配。她有着直直的黑色长发，表情中立，目光直视前方。背景是浅灰色的，突出了服装。胶片质感。',
    textExampleMessage10:
      '一位韩国模特站在简约的背景前。她穿着一件大号的浅橄榄绿色编织开衫，带有帽兜，看起来非常舒适和休闲。开衫采用粗厚的针织面料，呈现出立体的几何图案。版型宽松，适合秋季或冬季的穿着。模特还戴着一顶深棕色的棒球帽，帽子上的标志清晰可见。她的表情中性，眼神朝向一侧，给人一种轻松自在的感觉。整体风格偏向于休闲和时尚，强调舒适感和现代感。照片呈现胶片质感。',
    textExampleMessage11:
      '一位模特站在中性背景前。她穿着一件独特的米白色服装，带有宽大的袖子和不对称的下摆设计，多层面料堆叠并具有中式的风格。面料柔软流畅并呈现一些纹理，面料由轻盈的棉或丝绸混纺制成。版型宽松，具有现代感，既舒适又时尚。颜色以米白色为主，黑色裤子提供对比。整体风格偏向极简主义，带有一丝优雅。模特外表整洁，发型简洁，表情淡然，为整体造型增添了一份冷静和自信。',
    generationRatioTitle: '生成比例',
    tryText: '试一试',
    freeProportionText: '自由比例'
  },
  tune: {
    tuneTools: '智能换色',
    maskDialogTitle: '选择修改的区域',
    maskDesc: '请选择需要修改的区域',
    promptTitle: '画面描述'
  },
  expansion: {
    aiExpansion: 'AI扩图',
    flowerPatternExpansion: '四方连续'
  },
  pattern: {
    maskDialogTitle: '选择贴图的区域',
    maskDesc: '请选择需要贴图的区域',
    assistImagesTitle: '花型',
    pattern: '图案',
    printing: '印花',
    patternExtractionTitle: '花型提取',
    patternExtraction: '图案提取',
    printingExtraction: '印花提取',
    patternExtractionDesc: '较好的保存图案细节，适合用于提取整张图案。',
    printingExtractionDesc: '适合用于提取印花。',
    confirmButtonText: '确认图案'
  },
  material: {
    materialConversion: '材质转换',
    referenceImage: '上传参考材质',
    referenceImageDesc: '将参考材质拖拽到画布上，点击确定',
    reference: '参考材质'
  },
  clothes: {
    clothingExtraction: '服装提取',
    clothingTypeSelection: '服饰选择',
    tops: '上装',
    bottoms: '下装',
    dress: '连身服',
    topsAndBottoms: '上下装',
    shoes: '鞋子',
    hat: '帽子',
    package: '包袋',
    stylePicture: '款式图'
  },
  modelTryOn: {
    modelTryOnTools: '模特换装',
    modelImageDialogTitle1: '上传模特',
    modelImageDialogTitle2: '上传平铺图',
    maskDesc: '请涂抹需要换装的区域',
    maskDialogTitle: '涂抹需要换装的区域',
    upperBodyTitle: '上装/连衣裙',
    dressTitle: '下装',
    loadingText: '智能选区中，请稍等...',
    errorText: '智能选区失败，请重试',
    upperBodyMaskDialogTitle: '请选择上装/连衣裙的区域',
    dressMaskDialogTitle: '请选择下装的区域',
    singleMaskDialogTitle: '请选择衣服的区域',
    single: '单件上身',
    multi: '多件上身',
    singleTitle: '单件衣服'
  },
  modelFace: {
    modelFaceTools: '人脸抠图',
    uploadImageTitle: '上传原图',
    maskDesc: '请涂抹人像脸部的区域',
    selectModelTitle: '选择模特',
    maskDialogTitle: '涂抹人脸区域',
    modelSelectorDesc: '<span style="color: #4c4c4c; font-size: 14px">点击选择模特</span>',
    headSize: '头部大小',
  },
  diyModel: {
    sex: '性别',
    male: '男',
    female: '女',
    age: '年龄',
    kid: '儿童',
    juvenile: '成人',
    adult: '少年',
    youth: '青年',
    middleAged: '中年',
    elderly: '老年',
    color: '肤色',
    bodyShape: '体型',
    hair: '头发',
    length: '长度',
    hairstyle: '发型',
    slenderBody: '苗条身材',
    hourglassBody: '均匀身材',
    muscularBody: '肌肉发达',
    babyFatBody: '婴儿肥',
    shortAndFatBody: '矮胖身材',
    curvaceousBody: '曲线窈窕',
    straight: '直发',
    wavy: '波浪发',
    curly: '卷曲发',
    braided: '编织发',
    naturallyCurly: '自然卷',
    updo: '盘发',
    airBangs: '空气刘海',
    dreadlocks: '脏辫',
    ponytail: '马尾辫',
    bald: '光头',
    centerPartedHair: '中分发型',
    bangs: '齐刘海',
    frontBangs: '前发束',
    short: '短发',
    long: '长发',
    shoulderLength: '披肩发',
    extraLongHair: '超长发',
    pixieCut: '耳际短发',
    collarboneLengthHair: '及肩发',
    shoulderLengthHair: '齐肩发',
    waistLengthHair: '及腰发',
    fairSkinWhite: '白皙肤色',
    darkSkin: '黝黑肤色',
    yellowSkin: '黄皮肤',
    asian: '亚洲人',
    european: '欧洲人',
    african: '非洲人',
    american: '美洲人',
    middleEastern: '中东人'
  },
  maskDialogHelpTip: {
    mask: '鼠标点击需要保留的区域',
    matte: '上传图片，鼠标点击需要保留的区域，如果不需要抠图请直接点击确定按钮',
    cutout: '鼠标点击需要保留的区域',
    part: '鼠标点击需要作为蒙版的区域',
    objectRemoval:
      '如需去除部分前景内容，点击去前景，鼠标点击需要去除的区域，不需要则直接点击确定按钮'
  },
  helpTip: {
    helpTitle: '48小时实时服务',
    discord: 'LOOK AI 支持中心',
    helpCenter: '帮助中心',
    beginnerTutorialVideo: '新手教程视频',
    advancedTutorials: '高级教程',
    faq: 'FAQ',
    refundPolicy: '退款政策',
    contactSupport: '联系客服'
  },
  subscribe: {
    subscribeTitle:
      '首次开通会员特别&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">{discount}折</span>&nbsp;优惠',
    subscribeTitleFree:
      '请选择&nbsp;<span style="font-size: 24px; font-weight: 600">{number}天免费试用</span>&nbsp;结束后的计划',
    subscribeTitleFreeLocal:
      '首次订阅可以获得&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">7天免费会员</span>',
    person: '人',
    month: '月',
    year: '年',
    currency: '$',
    currencyLocal: '¥',
    firstMonthOnlyRenewsAt: '首月特惠，续费价格为',
    yearlyRenewsAt: '低至 {currency}{amount} / 天',
    trialText: '首次特惠',
    mostPopularText: '最受欢迎',
    noMemberText: '免费版',
    subscribeSubText:
      '会员到期后自动续费，<span style="color: #0d0d0d">次月恢复原价</span>，可随时取消',
    subscribeSubTextFree: '7天会员体验到期后自动续费，可随时取消',
    subscribeSubTextOneTime: '切换至连续包月，下月起低至1.9元起/天',
    priceNegotiableText: '价格面议',
    tryThisText: '最多人选择！',
    payButtonText1: '立即开通会员',
    payButtonText1Free: '￥0.00 领取{number}天免费会员！',
    payButtonText1FreeLocal: '￥0.00 领取7天免费试用！',
    payButtonText2: '立即开通',
    payButtonText3: '升级订阅',
    payButtonText3Local: '升级立享优惠',
    payButtonText4: '当前订阅',
    payButtonText5: '咨询客服',
    payButtonText6: '修改订阅',
    payButtonText7: '订阅',
    payMessage1: '为免费试用结束后的计划',
    payMessage2: '正在开通',
    payMessage3: '15天试用结束后支付',
    payMessage3Local: '7天试用结束后支付',
    payMessage4: '支付',
    payMessage5: '请扫码完成支付',
    payMessage6: '到期按 {currency}{amount}/月 自动续费，可随时取消',
    payMessage6Local:
      '<span style="color: #FF0000">连续包月，次月起 {currency}{amount}/月</span><br>自动续费，可随时取消',
    payMessage7: '体验到期按 {currency}{amount}/月 自动续费，可随时取消',
    payMessage7Local:
      '<span style="color: #FF0000">7天免费试用期结束后 {currency}{amount}/月</span><span style="text-decoration: line-through;">{currency}{originAmount}/月</span><br>连续包月，可随时取消',
    payMessage8: '请扫码完成签约',
    payMessage9:
      '签约领取&nbsp;&nbsp;<span style="font-size: 26px; font-weight: 700">免费</span>&nbsp;&nbsp;试用',
    alipayUpgradeTitle: '正在升级至',
    alipayUpgradeSubText:
      '购买一个月{member}会员，获赠时长全部升级，30天内的剩余付费会员时长等值抵扣。',
    paySuccessText: '订阅成功',
    paySubText: '开通即代表同意',
    freeMemberSuccessDesc: '将在15天会员体验结束后扣除费用，订购可随时取消，无需额外费用',
    freeMemberSuccessDescLocal: '将在7天会员体验结束后扣除费用，订购可随时取消，无需额外费用',
    receiveAwardTitle: '🎉欢迎使用LOOK',
    receiveAwardTitleTaskGuide: '🎉1天免费试用已到账！',
    receiveAwardTitleYearlyCoupon: '24小时欢迎礼包！',
    receiveAwardSubject:
      '我们为你准备了<span style="font-size: 24px; font-weight: 700">{number}天免费试用</span>',
    receiveAwardSubjectTaskGuide:
      '轻松体验 LOOK 核心功能',
    receiveAwardSubjectTaskGuideLocal: '轻松体验 LOOK 核心功能 <br/> 领取首次开通会员&nbsp;<span style="font-size: 20px; font-weight: 600">5折优惠！</span>',
    receiveAwardSubjectYearlyCoupon1: '首日限定 1000 点数已到账',
    receiveAwardSubjectYearlyCoupon1Local: '一天免费试用已解锁',
    receiveAwardSubjectYearlyCoupon2: '今日额外30%优惠',
    receiveAwardTipYearlyCoupon1: '比平常多 10 倍！',
    receiveAwardTipYearlyCoupon1Local: '轻松体验 LOOK 核心功能',
    receiveAwardTipYearlyCoupon2: '7天内全额退款',
    receiveAwardButtonTextYearlyCoupon: '立即开始免费试用',
    receiveAwardTip: '太少了？',
    memberTipsTrial: '首次体验超值优惠套餐，轻松开启新体验',
    receiveAwardButtonTextTaskGuide: '前往体验',
    receiveAwardButtonText: '{currency}0.00 领取{number}天免费试用！',
    receiveAwardButtonTextLocal: '{currency}0.00 领取{number}天免费试用！',
    memberInvitedOnly: '仅限受邀',
    memberTipsStarter: '适合个人设计师和人工智能新手。',
    memberTipsPlus: '适合需要高级人工智能工具的经验丰富的设计师',
    memberTipsPro: '适合寻求全面人工智能功能和高级特性的专业人士',
    memberTipsPersonal: '适合个人设计师、营销运营个人使用',
    memberTipsProfessional: '适合专业设计师、营销运营个人使用',
    memberTipsEnterprise: '适合工作室、企业使用',
    memberTipsEnterpriseCustomized: '支持私有化部署',
    memberFreeDesc1Label: '免费点数',
    memberFreeDesc1LabelLocal: '生成张数',
    memberFreeDesc1Value: '100/天',
    memberFreeDesc1ValueLocal: '8张/天',
    memberFreeDesc2Label: '生成清晰度',
    memberFreeDesc2Value: '高清',
    memberFreeDesc2ValueLocal: '标清',
    memberFreeDesc3Label: '同时进行任务数',
    memberFreeDesc3Value: '2',
    memberFreeDesc4Label: '实时设计',
    memberFreeDesc4Value: '无',
    memberDescStarter0Label: '免费点数',
    memberDescStarter0LabelLocal: '生成张数',
    memberDescStarter0Value: '100/天',
    memberDescStarter0ValueLocal: '无限制',
    memberDescStarter1Label: '包含点数',
    memberDescStarter1LabelLocal: '生成速度',
    memberDescStarter1Value: '3000 / 月',
    memberDescStarter1ValueLocal: '普通',
    memberDescStarter2Label: '同时进行任务数',
    memberDescStarter2Value: '{count}',
    memberDescStarter3Label: '生成频率',
    memberDescStarter3Value: '50 / 4 h',
    memberDescStarter4Label: '高清放大频率',
    memberDescStarter4Value: '8 / 4 h',
    memberDescStarter5Label: '高清质量',
    memberDescStarter5Value: '2K',
    memberDescStarter6Label: '实时设计',
    memberDescStarter6Value: '1200 min / mo.',
    memberDescStarter7Label: '生成清晰度',
    memberDescStarter7Value: '高清',
    memberDescStarter8Label: 'AI润色',
    memberDescStarter9Label: '视觉搜索',
    memberDescPlus0Label: '免费点数',
    memberDescPlus0Value: '100/天',
    memberDescPlus1Label: '包含点数',
    memberDescPlus1Value: '6600 / 月',
    memberDescPlus2Label: '同时进行任务数',
    memberDescPlus2Value: '{count}',
    memberDescPlus3Label: '生成频率',
    memberDescPlus3Value: '150 / 4 h',
    memberDescPlus4Label: '高清放大频率',
    memberDescPlus4Value: '16 / 4 h',
    memberDescPlus5Label: '高清质量',
    memberDescPlus5Value: '3K',
    memberDescPlus6Label: '实时设计',
    memberDescPlus6Value: '3600 min / mo.',
    memberDescPlus7Label: '生成清晰度',
    memberDescPlus7Value: '超清',
    memberDescPlus8Label: 'AI润色',
    memberDescPlus9Label: '视觉搜索',
    memberDescPlus10Label: '专属客服',
    memberDescPro0Label: '免费点数',
    memberDescPro0Value: '100/天',
    memberDescPro1Label: '包含点数',
    memberDescPro1Value: '12400 / 月',
    memberDescPro2Label: '同时进行任务数',
    memberDescPro2Value: '{count}',
    memberDescPro3Label: '生成频率',
    memberDescPro3Value: '无限制',
    memberDescPro4Label: '高清放大频率',
    memberDescPro4Value: '48 / 4 h',
    memberDescPro5Label: '高清质量',
    memberDescPro5Value: '4K',
    memberDescPro6Label: '实时设计',
    memberDescPro6Value: '无限制',
    memberDescPro7Label: '生成清晰度',
    memberDescPro7Value: '超清',
    memberDescPro8Label: 'AI润色',
    memberDescPro9Label: '视觉搜索',
    memberDescPro10Label: '专属客服',
    memberDescPersonal1Label: '生成张数',
    memberDescPersonal1Value: '无限制',
    memberDescPersonal2Label: '生成频率',
    memberDescPersonal2Value: '50张 / 4小时',
    memberDescPersonal3Label: '实时设计',
    memberDescPersonal3Value: '1200分钟 / 月',
    memberDescPersonal4Label: '生成清晰度',
    memberDescPersonal4Value: '高清',
    memberDescPersonal5Label: '同时进行任务数',
    memberDescPersonal5Value: '{count}',
    memberDescPersonal6Label: '',
    memberDescPersonal6Value: '',
    memberDescPersonal7Label: '高清放大频率',
    memberDescPersonal7Value: '8张 / 4小时',
    memberDescProfessional1Label: '生成张数',
    memberDescProfessional1Value: '无限制',
    memberDescProfessional2Label: '生成频率',
    memberDescProfessional2Value: '150张 / 4小时',
    memberDescProfessional3Label: '实时设计',
    memberDescProfessional3Value: '3600分钟 / 月',
    memberDescProfessional4Label: '生成清晰度',
    memberDescProfessional4Value: '超清',
    memberDescProfessional5Label: '同时进行任务数',
    memberDescProfessional5Value: '{count}',
    memberDescProfessional6Label: '',
    memberDescProfessional6Value: '',
    memberDescProfessional7Label: '高清放大频率',
    memberDescProfessional7Value: '16张 / 4小时',
    memberDescEnterprise1Label: '生成张数',
    memberDescEnterprise1Value: '无限制',
    memberDescEnterprise2Label: '生成频率',
    memberDescEnterprise2Value: '无限制',
    memberDescEnterprise3Label: '高清放大频率',
    memberDescEnterprise3Value: '无限制',
    memberDescEnterprise4Label: '实时设计',
    memberDescEnterprise4Value: '无限制',
    memberDescEnterprise5Label: '生成清晰度',
    memberDescEnterprise5Value: '超清',
    memberDescEnterprise6Label: '同时进行任务数',
    memberDescEnterprise6Value: '{count}',
    memberDescEnterprise7Label: '可定制模特（需额外收费）',
    memberDescEnterprise7Value: '',
    memberDescEnterprise8Label: '可定制品牌风格模型（需额外收费）',
    memberDescEnterprise8Value: '',
    memberDescEnterpriseCustomized1Label: '生成张数',
    memberDescEnterpriseCustomized1Value: '无限制',
    memberDescEnterpriseCustomized2Label: '生成频率',
    memberDescEnterpriseCustomized2Value: '无限制',
    memberDescEnterpriseCustomized3Label: '实时设计',
    memberDescEnterpriseCustomized3Value: '无限制',
    memberDescEnterpriseCustomized4Label: '生成清晰度',
    memberDescEnterpriseCustomized4Value: '超清',
    memberDescEnterpriseCustomized5Label: '同时进行任务数',
    memberDescEnterpriseCustomized5Value: '无限制',
    memberDescEnterpriseCustomized6Label: '可定制模特（需额外收费）',
    memberDescEnterpriseCustomized6Value: '',
    memberDescEnterpriseCustomized7Label: '可定制品牌风格模型（需额外收费）',
    memberDescEnterpriseCustomized7Value: '',
    stripeConfirmMessage1: '正在处理订单',
    stripeConfirmMessage2: '请确认是否已订阅成功？',
    stripeConfirmMessage3: '为了验证你的信用卡是否有效，我们会预先授权 {currency}1',
    stripeConfirmMessage3Local: '为了验证你的信用卡是否有效，我们会预先授权 {currency}1',
    stripeConfirmMessage4:
      '这仅用于验证，<span style="font-weight: 600; color: #0d0d0d">并不会产生任何实际收费</span>，请放心。',
    stripeSuccessMessage: '订单已完成！',
    stripeFailedMessage: '验证失败，请重试或更换其他付款方式。',
    stripeConfirmButtonText: '已完成订阅',
    stripeCancelButtonText: '取消操作',
    stripeEditBillingMessage: '正在进行修改订阅操作...',
    stripeEditBillingConfirmButtonText: '完成操作',
    stripeUpgradeMessage: '确定要升级订阅吗？',
    stripeUpgradeSuccessMessage: '升级成功！',
    stripeSubscribeRenewButtonText: '恢复续费',
    stripeSubscribeRenewConfirmMessage: '确定恢复续费吗？',
    stripeSubscribeRenewSuccessMessage: '已恢复续费',
    stripeSubscribeCancelButtonText: '取消订阅',
    stripeSubscribeCancelConfirmMessage: '确定取消续费吗？',
    stripeSubscribeCancelSuccessMessage: '已取消续费',
    cancelQuestionaireTitle: '告诉我们你取消订阅的原因',
    cancelQuestionaireSubject: '请你选择以下选项（单选），帮助我们了解取消订阅的原因。',
    cancelQuestionaireSelection1: '就是想取消订阅',
    cancelQuestionaireSelection2: '价格过高',
    cancelQuestionaireSelection3: '服务内容不再符合我的需求',
    cancelQuestionaireSelection4: '使用体验不佳',
    cancelQuestionaireSelection5: '技术问题（例如频繁的错误或中断）',
    cancelQuestionaireSelection6: '发现了更好的替代品',
    cancelQuestionaireSelection7: '其他（请说明）',
    cancelQuestionaireSelection8: '更好的选择',
    cancelQuestionaireSubmiteButtonText: '提交',
    cancelQuestionaireCancelButtonText: '我会继续使用',
    cancelSuccessMainTitle: '你的订阅已取消',
    cancelSuccessSubject: '你将很快收到确认邮件',
    reactivateTitle: '不小心取消了？',
    reactivateSubject: '不用担心，我们帮你重新订阅！',
    reactivateButtonText: '立即重新订阅',
    upgradeTitle: '升级订阅',
    upgradeSubject: '你的订阅升级将立即生效。',
    upgradeDesc: '费用将根据本周期剩馀天数按比例计算，并从新计划的费中扣除。',
    qrcodeTimeout: '二维码已过期',
    clickToRefresh: '点击刷新',
    cycleText: '按月计费',
    cycleTextLocal: '连续包月',
    oneTimeText: '单月支付',
    yearlyText: '按年计费',
    paymentTypeMonthlyText: '连续包月',
    paymentTypeYearlyText: '按年计费',
    cycleTextFirst: '连续包月，次月起{currency}{amount}/月',
    alipayCancelConfirmMessage1: '当前订阅价格：{currency}{amount}/月',
    alipayCancelConfirmMessage2: '取消后重新订阅将恢复原价{currency}{amount}/月',
    alipayCancelConfirmButtonText: '仍然取消',
    alipayCancelConfirmCancelButtonText: '我再用用',
    freeUsageText: '今日剩余免费额度：{count}',
    currentSubscription: '当前订阅',
    expiredText: '{date} 续期',
    subscriptionPolicyText: '7天内全额退款'
  },
  similer: {
    similerTitle: '视觉搜索',
    similerWaitingMessage: '组件正在初始化，请稍后',
    similerSearchFailedMessage: '搜索失败，点击重试',
    similerNoSimilarMessage: '暂无相似图片',
    similerLoadingMoreDetailImageError: '高清图像加载失败，点击重试'
  },
  taskType: {
    generate: '图片生成',
    upscale: '高清放大',
    realtimeDesign: '实时设计'
  },
  rewardTask: {
    rewardTaskListTitle1: '体验核心功能领取5折优惠',
    rewardTaskListTitle1Intl: '体验核心功能',
    rewardTaskListDesc1: '绑定手机',
    rewardTaskListGuide1: '绑定手机',
    rewardTaskListDesc2: '创建项目',
    rewardTaskListGuide2: '创建项目',
    rewardTaskListDesc3: '线稿生图',
    rewardTaskListGuide3: '点击或拖动上传图片，将线稿、款式图、时装画、真人照片变真实效果。',
    rewardTaskListDesc4: '线稿生图（色彩还原）',
    rewardTaskListGuide4:
      '线稿生图中，打开 <span style="color: #4c4c4c; font-weight: 600; text-decoration-line: underline">色彩还原</span>  <img src="{img}" style="vertical-align: middle;" />  会参考原稿的颜色，不开则随机生成。',
    rewardTaskListDesc5: '款式延伸',
    rewardTaskListGuide5: '在款式延伸功能，AI能根据上传的成衣图片，快速改款形成系列。',
    rewardTaskListDesc6: '风格融合',
    rewardTaskListGuide6: '风格融合需上传两张图片，实现服装+灵感素材相融，呈现不同时尚风格的碰撞。',
    rewardTaskListDesc7: '文生图',
    rewardTaskListGuide7:
      '输入对设计的描述生成 LOOK。可以使用  <img src="{img}" style="vertical-align: middle; width: 13px; height: 13px;" />  AI润色 和 图片描述辅助描述书写。',
    getRewardButtonText1: '完成',
    getRewardButtonText1Local: '领取首次订阅 5折 优惠',
    sketchToImageInitPrompt:
      '一位美丽的模特身着不对抹胸礼服，宽松的裙摆带有大褶皱和波浪，深色光泽感面料。搭配一双深色的尖头高跟鞋，这件连衣裙散发着优雅和现代感，有些许金属质感的光泽感面料。',
    sketchToImageColorInitPrompt:
      '时尚照片，照片中的模特身着优雅的服装，包括银灰色亚麻长裙、黑色高领毛衣和暖黄色格子背心，这套服装包括厚底高筒靴和一条暖黄色黑格纹腰带，腰带上饰有大蝴蝶结。背心和裙子上饰有几何图案。她的头发在额头处高高地梳着，戴着太阳镜。全身照。',
    styleExtensionInitPrompt:
      '一款高级时装，包含一件剪裁利落的短款西装外套，搭配锐利翻领和不对称口袋设计，背景为白色。外套搭配一条高腰、层叠式设计的裙子，裙摆具有流动感和不对称下摆，整体廓形强调前卫风格，结合精致剪裁与柔和垂坠感。材质为轻薄哑光面料，如棉或棉混纺，柔软但富有结构感。低饱和的泥土绿色突显极简与现代美感。设计在现代剪裁与艺术流动感之间取得平衡，适合走秀或时尚大片拍摄。产品摄影，高度细节纹理。',
    styleFusionInitPrompt: '一件粗针织彩色毛衣，胸前有一个立体针织的蝴蝶结图案，白色背景',
    text2ImageInitPrompt:
      '一位模特，身穿宽大的西装外套和皮裙，双腿修长，脚穿靴子，靴后点缀着巨大的蝴蝶结。模特摆出时尚姿态，仿佛拍摄《Vogue》时尚大片。背景为纯白墙，画面风格超现实且极为精细。',
    limitTime: '限时  ',
    guideStartButtonText: '去生成',
    confirmCloseDialogTitle: '跳过教程',
    confirmCloseDialogDesc: '你确定要跳过教程吗？你之后将无法再次查看。',
    confirmCloseDialogCancelButtonText: '取消',
    confirmCloseDialogConfirmButtonText: '跳过',
    rewardTitle: '你的设计福利已到账！',
    rewardDescription: '领取专属优惠券，解锁全新强大设计功能！',
    discountUnit: '折',
    couponType1: '会员折扣券',
    couponType2: '会员代金券',
    expiredText: '有效期至：',
    useNow: '立即使用！'
  },
  contextMenu: {
    copy: '复制',
    paste: '粘贴',
    selectAll: '全选'
  },
  login: {
    success: '你好，设计师！',
    closeWindow: '您已成功登录，可以关闭此页面'
  },
  update: {
    updateDialogTitle: '更新提示',
    updateDialogMessage: '检测到新版本，是否更新？',
    updateDialogCurrentVersion: '当前版本',
    updateDialogNewVersion: '新版本',
    updateDialogCancelButtonText: '暂不更新',
    updateDialogUpdateButtonText: '立即更新',
    updateDialogUpdateButtonLoadingText: '正在更新...'
  },
  updateError: {
    updateErrorDialogTitle: '更新失败',
    updateErrorDialogMessage: '更新失败，请稍后再试',
    updateErrorDialogButtonText: '确定'
  },
  updateProgress: {
    updateProgressDialogTitle: '正在更新'
  },
  remainingBalance: {
    realTimeDesign: '实时设计',
    minute: '分钟',
    hour: '小时',
    frequency: '生成频率',
    upscale: '高清放大频率',
    last: '最近',
    image: '张',
    unlimited: '无限制'
  },
  compositor: {
    opacity: '不透明度',
    saturation: '饱和度',
    brightness: '亮度',
    contrast: '对比度',
    hue: '色相',
    depthMapFailed: '深度图生成失败，请重新上传款式图'
  },
  coupon: {
    couponListTitle: '我的券',
    couponExpireCountdown: '剩余时间：',
    couponExpire: '有效期至：',
    couponListEmpty: '还没有优惠券哦',
    couponListEmptyDescription1: '快来加入我们的官方 Discord 频道',
    couponListEmptyDescription2: '参与活动领取好礼！',
    couponListEmptyButton: '前往 Discord'
  },
  plugins: {
    pluginsTitle: '插件市场',
    addPluginButtonText: '添加',
    removePluginButtonText: '移除',
    addedPluginButtonText: '已添加',
    noImages: '暂无插件图片',
    noPluginComponentText: '未找到插件页面，请确认插件是否已正确配置',
    editPluginsButtonText: '编辑插件',
    editPluginsCompletedButtonText: '完成编辑',
    morePluginsButtonText: '更多插件',
    removePluginTipsTitle: '移除插件',
    removePluginTips1: '被移除的插件可以从',
    removePluginTips2: '<span style="color: #0d0d0d; font-weight: 600;">插件市场</span> 内重新添加',
    pluginDisabled: '插件不可用',
    pluginsTips: {
      title: 'LOOK AI',
      subtitle: '插件市场来啦！',
      plugintipTitle1: '功能集合：',
      plugintipDesc1:
        '我们把原本分散的实用小功能，「智能换色」 「AI换场景」 「魔术擦除」 「一键抠图」等，全部打包进插件市场，只要去插件市场Pin一下，熟悉的功能秒回来',
      plugintipTitle2: '界面DIY：',
      plugintipDesc2:
        '进入插件市场 > 添加插件 > 在左侧工具栏点击「编辑插件」，上下拖动插件图标，想怎么排就怎么排！你的LOOK你做主',
      plugintipTitle3: '想要更多插件？联系我们！',
      plugintipDesc3:
        '我们将持续丰富更多实用插件，你想要的其他小功能，或者使用LOOK的感受和优化建议，LOOK为你而生，我们期待你的声音，并将努力满足你的每个小需求'
    },
    pluginsTipsFooter: {
      discord: '加入Discord社群',
      instagram: '在Instagram查看更多',
      email: '发送邮件：{email}'
    }
  },
  guide: {
    guideTitleVideo: '快速上手：1分钟视频',
    guideTitleBook: '常见问题与技巧',
    guideTitleSmallGift: '今日额外 30% 优惠',
    guideTitleSmallGiftDesc1: '低至每日 $0.56',
    guideTitleSmallGiftDesc2: '7天内全额退款',
    guideTitleSmallGiftDesc3: '48小时账单支持',
    guideTitleSmallGiftDesc4: '365天技术支持'
  },
  token: {
    usageDialogTitle: '使用情况',
    creditsTitle: 'LOOK 点数',
    dailyCredits: '每日点数',
    planCredits: '{plan} 计划点数',
    campaignCredits: '奖励点数',
    extraCredits: '额外点数',
    buyMoreCreditsButtonText: '购买更多点数',
    detailTableTitle: '明细',
    detailTableDate: '日期',
    detailTableCreditChange: '点数变化',
    usage: '使用情况',
    claimVoucher: '领取优惠券',
    buyMoreCreditsDialogTitle: '购买额外点数',
    buyMoreCreditsDialogDesc1: '请选择需要购买的额外点数额度，额外点数能保存1年。您可以查看我们的',
    buyMoreCreditsDialogDesc2: '来了解更多。',
    buyingCredits: '购买中...',
    creditsRule: '点数消耗规则',
    buyMoreCreditsDialogButtonText: '购买',
    discount: '{number}折',
    inPlanCredits: '计划点数',
    dailyCreditsTips: '获得 100 每日点数',
    expriredAt: '有效期至：{date}',
    buyCreditsSuccessText: '购买成功'
  },
  styleImagePrinting: {
    title: '款式图上印花',
    uploadStyleImage: '款式图',
    uploadPrintImage: '印花',
    printImageSize: '印花大小',
    promptExample: '示例：真丝面料'
  },
  announcementTips: {
    title: 'LOOK AI',
    subtitle: '插件 & 点数重大更新！',
    subtitle2: '新插件上线|计费系统升级|会员专属补偿',
    plugintipTitle1: '5款全新插件上线！',
    plugintipDesc1:
      '我们的插件市场迎来 5 款全新插件：服装提取，图案提取，材质转换，款式图，款式图 × 印花。涵盖更多设计风格与应用场景，让你在 LOOK 中的创作体验更加丰富高效。',
    plugintipTitle2: '计费系统全新升级，更灵活透明',
    plugintipDesc2:
      '为了支持更多样化的插件服务与使用习惯，我们对原有计费系统进行了全面优化：',
    plugintipDesc2Desc1: '新的点数体系将替代原有付费模式模式',
    plugintipDesc2Desc2: '你将获得更清晰的使用预期和点数分配方式',
    plugintipDesc2Desc3: '👉 详细说明请参考',
    plugintipDesc2Desc3Link: '点数规则说明',
    plugintipTitle3: '订阅用户专属感谢回馈',
    plugintipDesc3:
      '为了感谢大家一直以来的信任与支持，我们将为当前的付费用户发放额外点数，具体如下：',
    plugintipDesc3Desc1: '月付用户可获得相当于半个月的额外点数。',
    plugintipDesc3Desc2: '年付用户可获得相当于两个月的额外点数。',
    plugintipDesc3DescFooter: '额外点数已在新系统正式上线后自动发放进奖励点数额度中，可以在右上角点数明细中查看记录。如有任何问题请联系客服反馈。',
  },
  preAnnouncementTips: {
    title: 'LOOK AI',
    subtitle: '插件 & 点数重大更新！',
    subHeader: '新插件上线 {s} 计费系统升级 {s} 会员专属补偿',
    tipTitle1: '5款全新插件即将上线！',
    tipDesc1: '我们的插件市场即将迎来 5 款全新插件：服装提取、图案提取、材质转换、款式图、款式图 × 印花。涵盖更多设计风格与应用场景，让你在 LOOK 中的创作体验更加丰富高效。',
    tipTitle2: '计费系统全新升级，更灵活透明',
    tipDesc2: '为了支持更多样化的插件服务与使用习惯，我们对原有计费系统进行了全面优化：',
    tipDesc2Item1: '新的点数体系将替代原有付费模式模式',
    tipDesc2Item2: '你将获得更清晰的使用预期和点数分配方式',
    tipDesc2Item3: '👉 详细说明请参考 <span class="link-text">点数规则说明</span>',
    tipTitle3: '付费用户专属福利：更新补偿点数已准备',
    tipDesc3: '感谢每一位付费会员在过去对我们的支持与信任！本次系统更新期间，我们已为 所有在有效期内的付费会员 准备了额外点数补偿，用于感谢大家的持续支持与陪伴 ❤️',
    noticeText: '点数补偿将在新系统正式上线后自动发放，请关注软件内的弹窗领取。'
  },
  limited: {
    title: '升级为 {memberName} 会员获取更多点数',
    titleMax: '额外点数包，按需补充灵感所需，马上继续生成',
    subtitle: '您当前的点数额度已全部使用完。',
    subject: '或者，你也可以购买额外点数包，按需补充灵感所需，马上继续生成！',
    listTitle: '升级体验更多',
    listItem1: '每日免费点数',
    listItem2: '每月更多 LOOK 点数',
    listItem3: '超清生成清晰度',
    listItem4: '更多同时进行任务数',
    listItem5: '专属客服',
    promise: '连续包年，7天内全额退款保障',
    allPlan: '查看所有套餐'
  }
}

export default zhCN as any
